module.exports = __webpack_public_path__ + "public/images/about-top-logo-bg.feb092232e9ce7b1d8fb032e6c47920c.svg";